/*
 * SIJL - kortingscode met gratis verzending (code RAAM van de raamsticker).
 *
 * De QR-code op de raamsticker gaat naar sijl.nl/discount/RAAM. Shopify zet de
 * code dan op de winkelwagen, maar rekent hem pas bij het afrekenen: in de
 * winkelwagen bestaan nog geen verzendkosten. Zonder dit bestand zag de klant
 * daar dus nog "Nog € .. tot gratis verzending" en "+ € 8,95", terwijl de
 * verzending met de code al gratis is.
 *
 * Wat dit bestand doet:
 *  1. Het kijkt in /cart.js of een van de codes hieronder op de winkelwagen
 *     staat. Alleen de winkelwagen telt: daar staat wat er bij het afrekenen
 *     meegaat. Na het afrekenen begint Shopify een nieuwe, lege wagen zonder
 *     code, dus dan verdwijnt alles vanzelf.
 *  2. Staat de code erop en is hij toepasbaar, dan krijgt <html> de klasse
 *     sijl-gratis-verzending-code. De voortgangsbalk (blocks/_cart-title.liquid)
 *     en de verzendregel (blocks/_cart-summary.liquid) hebben voor dat geval al
 *     een eigen tekst klaarstaan; de klasse zet die aan. We schrijven dus niets
 *     in de winkelwagen zelf, en het blijft kloppen als Horizon de winkelwagen
 *     na een wijziging opnieuw tekent.
 *  3. Wie via de link binnenkomt, krijgt één keer per bezoek een korte melding
 *     dat de code actief is. Dat 'al gezien' onthouden we alleen voor dit
 *     bezoek (sessionStorage); er blijft niets in de browser achter.
 *  4. Shopify zet bij de link ook het cookie discount_code. Dat blijft staan tot
 *     de browser dicht gaat, ook als de code niet meer op de wagen staat (na het
 *     afrekenen, of als de klant hem bij het afrekenen weghaalde). Staat onze
 *     code wel in het cookie maar niet meer op de wagen, dan halen we het cookie
 *     weg, zodat een gebruikte code niet bij een volgende bestelling opduikt.
 *
 * Nog een code met gratis verzending? Zet hem in CODES; de teksten in de
 * winkelwagen zijn algemeen ("met je kortingscode") en hoeven niet mee.
 *
 * De opmaak van de melding staat hieronder, net als in sijl-winkelwagen.js:
 * sijl-custom.css is te groot om voor een klein onderdeel opnieuw te versturen.
 */

(function () {
  'use strict';

  var CODES = {
    RAAM: {
      titel: 'Code RAAM is actief',
      tekst: 'Gratis verzending op je eerste bestelling in Nederland. Dit wordt automatisch verrekend bij het afrekenen.'
    }
  };

  var KLASSE = 'sijl-gratis-verzending-code';
  var GEZIEN = 'sijl-code-melding';

  function bekend(code) {
    return code && Object.prototype.hasOwnProperty.call(CODES, code) ? code : null;
  }

  function wisCookie() {
    document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax';
  }

  function uitCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return null;
    var waarde = m[1];
    try {
      waarde = decodeURIComponent(waarde);
    } catch (e) {
      /* dan gebruiken we hem zoals hij is */
    }
    return bekend(String(waarde).trim().toUpperCase());
  }

  /* Geeft { code, toepasbaar } terug als een van onze codes op de wagen staat. */
  function uitWagen(wagen) {
    var lijst = (wagen && wagen.discount_codes) || [];
    for (var i = 0; i < lijst.length; i++) {
      var code = bekend(String(lijst[i].code || '').trim().toUpperCase());
      if (code) return { code: code, toepasbaar: lijst[i].applicable !== false };
    }
    return null;
  }

  function haalWagen() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (antwoord) {
        return antwoord.ok ? antwoord.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function stijl() {
    if (document.getElementById('sijl-code-stijl')) return;
    var s = document.createElement('style');
    s.id = 'sijl-code-stijl';
    s.textContent =
      '.sijl-code-melding{position:fixed;z-index:2147483000;left:12px;right:12px;bottom:12px;' +
      'box-sizing:border-box;max-width:420px;margin:0 auto;display:flex;gap:12px;align-items:flex-start;' +
      'padding:14px 14px 14px 16px;border:1px solid #cf6114;border-radius:5px;background:#1a1a1a;color:#fff;' +
      'box-shadow:0 10px 30px rgb(0 0 0 / .25);font-size:14px;line-height:1.45;' +
      'opacity:0;transform:translateY(16px);transition:opacity .3s ease,transform .3s ease}' +
      '.sijl-code-melding--zichtbaar{opacity:1;transform:none}' +
      '.sijl-code-melding__streep{flex:0 0 4px;align-self:stretch;border-radius:2px;background:#cf6114}' +
      '.sijl-code-melding__inhoud{flex:1 1 auto;min-width:0}' +
      '.sijl-code-melding__titel{margin:0 0 3px;font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}' +
      '.sijl-code-melding__tekst{margin:0;opacity:.85}' +
      '.sijl-code-melding__sluit{flex:0 0 auto;margin:-4px -4px 0 0;padding:4px 8px;border:0;background:none;' +
      'color:inherit;font-size:20px;line-height:1;cursor:pointer;opacity:.7}' +
      '.sijl-code-melding__sluit:hover,.sijl-code-melding__sluit:focus-visible{opacity:1}' +
      '@media (min-width:750px){.sijl-code-melding{left:24px;right:auto;bottom:24px;margin:0}}' +
      '@media (prefers-reduced-motion:reduce){.sijl-code-melding{transition:none;transform:none}}';
    document.head.appendChild(s);
  }

  function melding(code) {
    try {
      if (window.sessionStorage.getItem(GEZIEN) === code) return;
      window.sessionStorage.setItem(GEZIEN, code);
    } catch (e) {
      /* Geen sessionStorage (privévenster): dan tonen we hem gewoon. */
    }

    /* Niet in de thema-editor: daar is het alleen maar in de weg. */
    if (window.Shopify && window.Shopify.designMode) return;

    stijl();

    var info = CODES[code];
    var blok = document.createElement('div');
    blok.className = 'sijl-code-melding';
    blok.setAttribute('role', 'status');
    blok.setAttribute('aria-live', 'polite');

    var streep = document.createElement('span');
    streep.className = 'sijl-code-melding__streep';
    streep.setAttribute('aria-hidden', 'true');

    var inhoud = document.createElement('div');
    inhoud.className = 'sijl-code-melding__inhoud';

    var titel = document.createElement('p');
    titel.className = 'sijl-code-melding__titel';
    titel.textContent = info.titel;

    var tekst = document.createElement('p');
    tekst.className = 'sijl-code-melding__tekst';
    tekst.textContent = info.tekst;

    var sluit = document.createElement('button');
    sluit.type = 'button';
    sluit.className = 'sijl-code-melding__sluit';
    sluit.setAttribute('aria-label', 'Melding sluiten');
    sluit.textContent = '×';

    inhoud.appendChild(titel);
    inhoud.appendChild(tekst);
    blok.appendChild(streep);
    blok.appendChild(inhoud);
    blok.appendChild(sluit);
    document.body.appendChild(blok);

    var timer = null;

    function weg() {
      window.clearTimeout(timer);
      blok.classList.remove('sijl-code-melding--zichtbaar');
      window.setTimeout(function () {
        if (blok.parentNode) blok.parentNode.removeChild(blok);
      }, 350);
    }

    sluit.addEventListener('click', weg);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        blok.classList.add('sijl-code-melding--zichtbaar');
      });
    });
    timer = window.setTimeout(weg, 9000);
  }

  /* Bepaalt of de winkelwagen de gratis verzending moet tonen. */
  function werkBij(wagen, eersteKeer) {
    /* Geen antwoord van de wagen: dan laten we alles zoals het is. */
    if (!wagen) return;

    var opWagen = uitWagen(wagen);
    document.documentElement.classList.toggle(KLASSE, !!(opWagen && opWagen.toepasbaar));

    /* Oud cookie van een code die niet meer op de wagen staat: opruimen. */
    var cookie = uitCookie();
    if (cookie && (!opWagen || opWagen.code !== cookie)) wisCookie();

    /* De melding alleen als de code echt op de wagen staat. Bij een lege wagen
       noemt Shopify hem nog niet toepasbaar, maar hij staat er wel op. */
    if (eersteKeer && opWagen) melding(opWagen.code);
  }

  function start() {
    haalWagen().then(function (wagen) {
      werkBij(wagen, true);
    });

    document.addEventListener('cart:update', function () {
      haalWagen().then(function (wagen) {
        werkBij(wagen, false);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
